(function () {

	'use strict';

    $(document).ready(function () {
        cologic.initContactForm();
    });


	let cologicCustomKontakt = {

        initContactForm: function(){
            let that = this;
            $('.kontaktform').each(function(el){
                $('.infoCol', this).hide();
                that.configForm($('.betreff', this).val(), this);
                let that2 = this;
                $('.betreff', this).on('change load', function(){
                   let formConfig = $(this).val();
                   that.configForm(formConfig, that2);
                });
            });
        },


        configForm: function(formparam, that){
            switch(formparam){

                case 'verbraucher':
                    $('.infoCol', that).hide();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-verbraucher', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break

                case 'reklamation':
                    $('.infoCol', that).hide();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-reklamation', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.firmaSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.plzSet', that).addClass('active');
                    $('.ortSet', that).addClass('active');
                    $('.strasseSet', that).addClass('active');
                    $('.hausnummerSet', that).addClass('active');
                    $('.landSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.kategorieSet', that).addClass('active');
                    $('.mhdSet', that).addClass('active');
                    $('.chargennummerSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break

                case 'vertrieb':
                    $('.infoCol', that).hide();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-vertrieb', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break

                case 'marketing':
                    $('.infoCol', that).hide();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-marketing', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break

                case 'karriere':
                    $('.infoCol', that).show();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-karriere', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break

                case 'gastronomie':
                    $('.infoCol', that).show();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-gastronomie', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break

                case 'fruehshoppen':
                    $('.infoCol', that).show();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-fruehshoppen', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break

                case 'hotel':
                    $('.infoCol', that).show();
                    $('.infoCol .contact-info', that).hide();
                    $('.infoCol .contact-info.contact-info-hotel', that).show();

                    $('.formSet', that).removeClass('active');
                    $('.anliegenSet', that).addClass('active');
                    $('.anredeSet', that).addClass('active');
                    $('.vornameSet', that).addClass('active');
                    $('.nachnameSet', that).addClass('active');
                    $('.emailSet', that).addClass('active');
                    $('.telefonSet', that).addClass('active');
                    $('.nachrichtSet', that).addClass('active');
                    $('.dateiSet', that).addClass('active');
                    $('.newsletterSet', that).addClass('active');

                    break
            }

        },


		formok: true,


		setKontakt: function () {

			let that = this;
			$('.valCheck').bind('input', function () {
				that.validateTextField($(this), $(this).val());
			}).bind('change', function () {
				that.validateTextField($(this), $(this).val());
			});

			$('.siteUrl').val(window.location);
		},


		// Validierung
		validateTextField: function (_elem, _val) {

			let that = this;
			if($(_elem).prop('required') || $(_elem).val() !== '' ) {

				switch ($(_elem).attr('id')) {
					case 'vorname' :
					case 'nachname' :
					case 'firma' :
						if (_val.length > 2) {
							if (that.validateText(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'anrede' :
					case 'betreff' :
						if (_val) {
							if (!$(_elem).hasClass('fgBlack')) {
								$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'nachricht' :
						if (_val.length > 2) {
							if (that.validateMessage(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'telefon' :
					case 'telefonPopup' :
						if (_val.length > 4) {
							if (that.validatePhone(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}
							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'email' :
						if (_val.length > 5) {
							if (that.validateEmail(_val)) {
								if (!$(_elem).hasClass('fgBlack')) {
									$(_elem).addClass('fgBlack validatedBorder').removeClass("error");
								}

							} else {
								if ($(_elem).hasClass('fgBlack')) {
									$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).hasClass('fgBlack')) {
								$(_elem).removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

					case 'fileInput1' :
						if (_val.length > 0) {
							if (_val.endsWith('.pdf') || _val.endsWith('.doc') || _val.endsWith('.docx') || _val.endsWith('.txt')) {
								if (!$(_elem).parent().find('span').hasClass('fgBlack')) {
									$(_elem).parent().find('span').addClass('fgBlack validatedBorder').removeClass("error");
								}

							} else {
								if ($(_elem).parent().find('span').hasClass('fgBlack')) {
									$(_elem).parent().find('span').removeClass('fgBlack validatedBorder').addClass('error');
								}
								that.formok = false

							}
						} else {
							if ($(_elem).parent().find('span').hasClass('fgBlack')) {
								$(_elem).parent().find('span').removeClass('fgBlack validatedBorder').addClass('error');
							}
							that.formok = false

						}

						break;

				}

			}

		},


		// Text validieren
		validateText: function ($text) {
			let textReg = /^[a-zA-ZäöüÄÖÜß0-9.,_\-&/+ ']{2,50}$/;
			return textReg.test( $text );
		},

		// Textarea validieren
		validateMessage: function ($text) {
			let messageReg = /^[a-zA-ZäöüÄÖÜß0-9.,;:!?()%$§€@_#*"´`\-&/+ '\r\n\t]{2,}$/;
			return messageReg.test( $text );
		},

		// Telefon validieren
		validatePhone: function ($phone) {
			let phoneReg = /^[0-9\-/+ ']{4,30}$/;
			return phoneReg.test( $phone );
		},

		// E-Mail validieren
		validateEmail: function ($email) {
			let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
			return emailReg.test( $email );
		},


		// Error & Required Check

		finalFormCheck: function (formId, _elem) {

			let that = this;

			that.formok=true;

			$('#'+formId+' .valCheck').each(function(){
				if($(this).prop('required')){
					that.validateTextField( $(this), $(this).val() );
				}
			});




			$('#'+formId+' .confirmation').each(function(){
				that.dataProtectConfirm( $(this) );
			});
			console.log(that.formok);
            if (that.formok) {
                if (!$(_elem).data('isclicked')) {
                    that.sendForm(formId);
                    that.scrollToId(formId);
                    $(_elem).data('isclicked', true);
                    setTimeout(function () {
                        $(_elem).removeData('isclicked');
                    }, 5000);
                }


            } else {

                $('.errorFeedBack').css('visibility', 'visible');
            }

		},

        scrollToY: function (_y) {
            $('html, body').animate({scrollTop: _y}, '200');
        },
        scrollToId: function (_id) {
            let offSet = $('#header').innerHeight();
            this.scrollToY($('#' + _id).offset().top - (offSet + 50));
        },

		checkFormFiled: function (_id) {

			if ( !$('#'+_id ).hasClass('fgBlack') ){
				$('#'+_id ).addClass('error')
				this.formok = false
			}

		},


		dataProtectConfirm: function (_elem) {

			if(!$(_elem).prop('checked')){
				$(_elem).addClass('error');
				this.formok = false;
			}else{
				$(_elem).removeClass('error');
			}
		},


		sendForm: function (_id) {

			$('#' + _id + ' .errorFeedBack').hide();

			let inVals;

			let form = document.forms.namedItem(_id);
			inVals = new FormData(form);

				this.queryMailandler(false, inVals, function (response_Data) {
					if (response_Data) {
						$('#' + _id + ' .contactResponse').removeClass('inactive').find('.innerResponse').html(response_Data);

					} else {
						$('#' + _id + ' .contactResponseFailed').removeClass('inactive');


					}
				});

		},

		closeResponse: function () {
			$('.contactResponse').addClass('inactive');
			$('.overlay-container').addClass('hide');
		},

		closeResponseFailed: function () {
			$('.contactResponseFailed').addClass('inactive');
			$('.overlay-container').addClass('hide');
		},


        //------------------------------

        /*********** Ajax DB Abfragen Start ******************/

        // mailHandlerURL: _baseUrl + "index.php?id=16",

    queryMailandler: function (handleAsJson, _params, ajaxCallback) {
        let trgAdress = '/mailresponse';
            $.ajax({
                type: 'post',
                cache: false,
                data: _params,
                url: trgAdress,
                processData: false,
                contentType: false

            })
                .done(function (data) {
                    try {
                        let response;
                        //remove BOM + parse json
                        if (handleAsJson) {
                            response = $.parseJSON(data.trim());
                        } else {
                            response = data.trim();
                        }

                        if (ajaxCallback)
                            ajaxCallback(response);
                        return (response);

                    } catch (err) {
                        alert("Fehler: " + err);
                    }
                })
                .fail(function (err) {
                    alert("Es ist ein Fehler aufgetreten: " + err);
                });
        },

        showFilename: function (e) {
            $(e).prev('span').html($(e)[0].files[0].name);
        }

    }

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicCustomKontakt);
}());